import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Education from './components/Education';
import Documents from './components/Documents';
import WorkStyle from './components/WorkStyle';
import Personal from './components/Personal';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollNav from './components/ScrollNav';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        <Navbar />
        <ScrollNav />
        <main>
          <Hero />
          <About />
          <Experience />
          <Skills />
          <Education />
          <Documents />
          <WorkStyle />
          <Personal />
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;